import React, { useState } from 'react';

function DesbloquearDiaModal({ isOpen, onClose, bloqueios, onDesbloquear }) {
    const [searchTerm, setSearchTerm] = useState('');

    if (!isOpen) return null;

    const filteredBloqueios = bloqueios.filter(b =>
        b.auditor.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.data.includes(searchTerm) ||
        b.motivo.toLowerCase().includes(searchTerm.toLowerCase())
    ).sort((a, b) => b.data.localeCompare(a.data)); // Ordenar por data decrescente (mais recente primeiro)

    const handleRemove = (bloqueio) => {
        onDesbloquear(bloqueio.data, bloqueio.auditor);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" style={{ maxWidth: '600px', width: '90%' }} onClick={(e) => e.stopPropagation()}>
                <h2>Gerenciar Desbloqueios</h2>
                <p style={{ marginBottom: '10px', color: '#666', fontSize: '0.9rem' }}>
                    Abaixo estão listados todos os dias bloqueados. Clique na lixeira para remover o bloqueio.
                </p>

                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Buscar por auditor, data ou motivo..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ padding: '8px', width: '100%', boxSizing: 'border-box' }}
                    />
                </div>

                <div className="bloqueios-list" style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
                    {filteredBloqueios.length === 0 ? (
                        <p style={{ padding: '20px', textAlign: 'center', color: '#999' }}>Nenhum bloqueio encontrado.</p>
                    ) : (
                        <table className="users-table" style={{ width: '100%', fontSize: '0.9rem' }}>
                            <thead style={{ position: 'sticky', top: 0, background: '#f8f9fa' }}>
                                <tr>
                                    <th style={{ padding: '8px' }}>Data</th>
                                    <th style={{ padding: '8px' }}>Auditor</th>
                                    <th style={{ padding: '8px' }}>Motivo</th>
                                    <th style={{ padding: '8px', textAlign: 'center' }}>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredBloqueios.map((bloqueio) => (
                                    <tr key={bloqueio.id} style={{ borderBottom: '1px solid #eee' }}>
                                        <td style={{ padding: '8px', whiteSpace: 'nowrap' }}>
                                            {new Date(bloqueio.data + 'T00:00:00').toLocaleDateString('pt-BR')}
                                        </td>
                                        <td style={{ padding: '8px' }}><strong>{bloqueio.auditor}</strong></td>
                                        <td style={{ padding: '8px' }}>{bloqueio.motivo}</td>
                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                            <button
                                                onClick={() => handleRemove(bloqueio)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: '1.2rem',
                                                    color: '#dc3545'
                                                }}
                                                title="Remover Bloqueio"
                                            >
                                                🗑️
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                <div className="modal-actions" style={{ marginTop: '20px' }}>
                    <button type="button" onClick={onClose} className="btn-cancel">Fechar</button>
                </div>
            </div>
        </div>
    );
}

export default DesbloquearDiaModal;
